/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { popupAdminControllerCreateV1 } from '../fn/popup-admin/popup-admin-controller-create-v-1';
import { PopupAdminControllerCreateV1$Params } from '../fn/popup-admin/popup-admin-controller-create-v-1';
import { popupAdminControllerDeleteV1 } from '../fn/popup-admin/popup-admin-controller-delete-v-1';
import { PopupAdminControllerDeleteV1$Params } from '../fn/popup-admin/popup-admin-controller-delete-v-1';
import { popupAdminControllerFindAllV1 } from '../fn/popup-admin/popup-admin-controller-find-all-v-1';
import { PopupAdminControllerFindAllV1$Params } from '../fn/popup-admin/popup-admin-controller-find-all-v-1';
import { popupAdminControllerFindByIdV1 } from '../fn/popup-admin/popup-admin-controller-find-by-id-v-1';
import { PopupAdminControllerFindByIdV1$Params } from '../fn/popup-admin/popup-admin-controller-find-by-id-v-1';
import { popupAdminControllerReorderV1 } from '../fn/popup-admin/popup-admin-controller-reorder-v-1';
import { PopupAdminControllerReorderV1$Params } from '../fn/popup-admin/popup-admin-controller-reorder-v-1';
import { popupAdminControllerSearchV1 } from '../fn/popup-admin/popup-admin-controller-search-v-1';
import { PopupAdminControllerSearchV1$Params } from '../fn/popup-admin/popup-admin-controller-search-v-1';
import { popupAdminControllerUpdateV1 } from '../fn/popup-admin/popup-admin-controller-update-v-1';
import { PopupAdminControllerUpdateV1$Params } from '../fn/popup-admin/popup-admin-controller-update-v-1';
import { PopupDto } from '../models/popup-dto';

@Injectable({ providedIn: 'root' })
export class PopupAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `popupAdminControllerSearchV1()` */
  static readonly PopupAdminControllerSearchV1Path = '/api/v1/popups/admin';

  /**
   * 팝업 목록 조회 (관리자).
   *
   * 팝업을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupAdminControllerSearchV1$Response(params: PopupAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PopupDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = popupAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 목록 조회 (관리자).
   *
   * 팝업을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupAdminControllerSearchV1(params: PopupAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<PopupDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.popupAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<PopupDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<PopupDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `popupAdminControllerCreateV1()` */
  static readonly PopupAdminControllerCreateV1Path = '/api/v1/popups/admin';

  /**
   * 팝업 생성.
   *
   * 팝업을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupAdminControllerCreateV1$Response(params: PopupAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 생성.
   *
   * 팝업을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupAdminControllerCreateV1(params: PopupAdminControllerCreateV1$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupAdminControllerFindAllV1()` */
  static readonly PopupAdminControllerFindAllV1Path = '/api/v1/popups/admin/all';

  /**
   * 전체 팝업 목록 조회 (관리자).
   *
   * 팝업 전체 목록을 배열로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupAdminControllerFindAllV1$Response(params?: PopupAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
    const obs = popupAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 전체 팝업 목록 조회 (관리자).
   *
   * 팝업 전체 목록을 배열로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupAdminControllerFindAllV1(params?: PopupAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PopupDto>> {
    const resp = this.popupAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PopupDto>>): Array<PopupDto> => r.body)
    );
  }

  /** Path part for operation `popupAdminControllerFindByIdV1()` */
  static readonly PopupAdminControllerFindByIdV1Path = '/api/v1/popups/admin/{id}';

  /**
   * 팝업 ID 기반 조회 (관리자).
   *
   * 팝업을 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupAdminControllerFindByIdV1$Response(params: PopupAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 ID 기반 조회 (관리자).
   *
   * 팝업을 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupAdminControllerFindByIdV1(params: PopupAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupAdminControllerDeleteV1()` */
  static readonly PopupAdminControllerDeleteV1Path = '/api/v1/popups/admin/{id}';

  /**
   * 팝업 삭제.
   *
   * 팝업을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupAdminControllerDeleteV1$Response(params: PopupAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 삭제.
   *
   * 팝업을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupAdminControllerDeleteV1(params: PopupAdminControllerDeleteV1$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupAdminControllerUpdateV1()` */
  static readonly PopupAdminControllerUpdateV1Path = '/api/v1/popups/admin/{id}';

  /**
   * 팝업 수정.
   *
   * 팝업을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupAdminControllerUpdateV1$Response(params: PopupAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 수정.
   *
   * 팝업을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupAdminControllerUpdateV1(params: PopupAdminControllerUpdateV1$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupAdminControllerReorderV1()` */
  static readonly PopupAdminControllerReorderV1Path = '/api/v1/popups/admin/reorder';

  /**
   * 팝업 순서 변경.
   *
   * 팝업의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupAdminControllerReorderV1$Response(params: PopupAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
    const obs = popupAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 순서 변경.
   *
   * 팝업의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupAdminControllerReorderV1(params: PopupAdminControllerReorderV1$Params, context?: HttpContext): Observable<Array<PopupDto>> {
    const resp = this.popupAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PopupDto>>): Array<PopupDto> => r.body)
    );
  }

}
